import { useState, useEffect } from "react"
import { useNumericMenu } from "react-instantsearch";
import { PLPFiltersTracking } from "../common/Tracking";
import { useDispatch, useSelector } from "react-redux";
import { setPriceAction } from "@/redux/actions/priceAction";
import { setFiltersSelectedFlag } from "@/redux/actions/filtersAction";

const CustomNumericMenu = (props) => {
  const { items, refine } = useNumericMenu(props)
  let pathArray = props.serverPath;
  pathArray = pathArray.split('?');
  const dispatch = useDispatch();
  const { renderFilterByLevelType, renderFilterLabel, level } = props
  const [startVal, setStartVal] = useState(null)
  const [endVal, setEndVal] = useState(null)
  const [filterCicked, setFilterClicked] = useState(null)
  const price_clear = useSelector((state) => state.price.price_filter_clear);
  //this code was required to retain the price filter when the page reload happens
  //once the page is reloaded if user manually change the price filter filterCicked will help not to execute below code
  useEffect(() => {
    if (pathArray[1] && !filterCicked) {
      setTimeout(() => {
        let priceQuery
        const urlParams = new URLSearchParams(pathArray[1]);
        priceQuery = urlParams.get(`${props.indexName}[numericMenu][price]`);
        let priceArr = [];
        if(priceQuery) {
          priceArr = priceQuery.split(':');
          if(priceArr[0] && priceArr[1]) {
            setStartVal(priceArr[0])
            setEndVal(priceArr[1])
            refine(`{"start": ${priceArr[0]}, "end": ${priceArr[1]}}`)
          } else if(priceArr[0]) {
            refine(`{"start":${priceArr[0]}}`)
          } else if(priceArr[1]) {
            refine(`{"end":${priceArr[1]}}`)
          }
          setFilterClicked(true);
        }
      }, 1000);
    }
  }, [])

  useEffect(() => {
    if (startVal && !isNaN(startVal) && !isNaN(endVal) && endVal > startVal) {
      setFilterClicked(true);
      refine(`{"start": ${startVal}, "end": ${endVal}}`)
      dispatch(setFiltersSelectedFlag(true));
    }
  }, [startVal, endVal])

  //Below code is used to clear the input values of min and max when user clear the filter pill
  useEffect(() => {
    if (price_clear) {
      setStartVal('')
      setEndVal('')
      dispatch(setPriceAction(false))
    }
  }, [price_clear])

  return (
    <>
      <li className="">
        <div className="price_range_aria">
          <div className="input-group">
            <label className="xx-small">Min</label>
            <input className="input-control small" autoComplete="min" aria-label="min-value" value={startVal} onChange={(e) => setStartVal(parseInt(e.target.value) > 0 ? parseInt(e.target.value) : '')} />
          </div>
          <div className="input-group">
            <label className="xx-small">Max</label>
            <input className="input-control small" autoComplete="max" aria-label="max-value" value={endVal} onChange={(e) => setEndVal(parseInt(e.target.value) > 0 ? parseInt(e.target.value) : '')} />
          </div>
        </div>
      </li>
      {items.map((singleElement) => {
        return (
          <li
            key={Math.random().toString()}
            // if anything types inside price input then checkboxes should disable.
            className={startVal && 'disabled'}
            //  price filters shouldnt be unselect
            onClick={() => {
              if (!singleElement.isRefined) {
                refine(singleElement.value);
                setFilterClicked(true);
                dispatch(setFiltersSelectedFlag(true));
                PLPFiltersTracking(
                  props.attribute.charAt(0).toUpperCase() + props.attribute.slice(1),
                  singleElement.label,
                  singleElement.isRefined
                );
              }
              // Scroll to top if not already at top
              if (typeof window !== "undefined" && window.scrollY > 0) {
                window.scrollTo({ top: 0, behavior: "auto" });
              }
            }}
          >
            <div className="custom-checkbox">
              {/* if items are of level0 then checkbox should disabled and also if  disable the input if something types on price input*/}
              {renderFilterByLevelType(props.attribute, singleElement, level, startVal)}
              <label className="small">
                <span>{renderFilterLabel(props.attribute, singleElement)}</span>
              </label>
            </div>
          </li>
        );
      })}
    </>
  )
}

export default CustomNumericMenu